const Footer = () => {
    return (
        <footer>
            <p>This site was designed and built by me :) © 2023 Taole Chen</p>
        </footer>
    )
};

export default Footer;